import { MODE } from '@/model/search-agent/rating'

export default {
    allDone: 'All macro-trends from the "{type}" area have been successfully processed.',
    [MODE.UNVOTED]: 'unassigned',
    [MODE.REJECTED]: 'declined',
    [MODE.ACCEPTED]: 'accepted'
}
